// extracted by mini-css-extract-plugin
export var details = "details-module--details--3EB46";